import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative min-w-[8rem] min-h-[8rem] aspect-square" }
const _hoisted_2 = {
  key: 0,
  class: "bg-gray-700 rounded-md animate-pulse h-full w-full m-auto sm:m-0"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "rounded-full p-1 bg-black text-yellow-400 w-6 h-6 absolute -right-2 -top-2"
}

import { Hitomi } from '@/model/hitomi';
import { getHitomiImage } from '@/repository/hitomi';
import { StarFilled } from '@ant-design/icons-vue';
import { ref, watch, onBeforeMount } from 'vue';
import LoadingSkeleton from '../shared/LoadingSkeleton.vue';

const imagePlaceholder =
	'https://www.signfix.com.au/wp-content/uploads/2017/09/placeholder-600x400.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'HitomiCard',
  props: {
    hitomi: {},
    mode: {}
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props;



onBeforeMount(async () => await fetchImage(props.hitomi.hitomiImageURL));

let url = ref('');
let isImageLoading = ref(true);


watch(
	() => props.hitomi.hitomiImageURL,
	async () => await fetchImage(props.hitomi.hitomiImageURL)
);

async function fetchImage(imageURL: string) {
	const res = await getHitomiImage(imageURL);
	if (res) {
		url.value = URL.createObjectURL(res);
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isImageLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LoadingSkeleton, {
            isLoading: _unref(isImageLoading),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', _ctx.hitomi))),
            disabledClick: "",
            link: _ctx.mode === 'EXTERNAL' ? _ctx.hitomi.hitomiLink : `/hitomi/${_ctx.hitomi.hitomiUUID}`
          }, null, 8, ["isLoading", "link"])
        ]))
      : _createCommentVNode("", true),
    (_unref(url).length > 0)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.mode === 'EXTERNAL' ? _ctx.hitomi.hitomiLink : `/hitomi/${_ctx.hitomi.hitomiUUID}`,
          onclick: "return false"
        }, [
          _createElementVNode("img", {
            alt: "",
            src: _unref(url),
            onLoad: _cache[1] || (_cache[1] = () => (_isRef(isImageLoading) //@ts-ignore
 ? isImageLoading.value = false : isImageLoading = false)),
            onError: _cache[2] || (_cache[2] = 
					() => {
						_isRef(isImageLoading) //@ts-ignore
 ? isImageLoading.value = false : isImageLoading = false;
						_isRef(url) //@ts-ignore
 ? url.value = imagePlaceholder : url = imagePlaceholder;
					}
				),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click', _ctx.hitomi))),
            class: _normalizeClass(
					(_unref(isImageLoading) ? 'w-0 h-0' : '!h-full !w-full cursor-pointer hover:brightness-75') +
					' object-cover rounded-md '
				),
            loading: "lazy",
            referrerPolicy: "no-referrer"
          }, null, 42, _hoisted_4)
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.hitomi.isFavorite && !_unref(isImageLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_unref(StarFilled))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})